import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { QuestionnaireService } from 'src/app/services/questionnaire.service';
import { environment } from 'src/environments/environment';



interface Question {
  question_id: number,
  question_type_id: number,
  image: string,
  question: string,
  answers: Answer[],
  selected: string,
  answersSet: any,
  questionsSet: any
}

interface Answer {
  id: number,
  answer: string,
  is_answer: boolean,
  selected: boolean
}


@Component({
  selector: 'app-test-viewer',
  templateUrl: './test-viewer.component.html',
  styleUrls: ['./test-viewer.component.scss']
})
export class TestViewerComponent implements OnInit, OnDestroy {


  questions: Question[];
  channel = this.route.snapshot.paramMap.get('testid')
  exam_name = this.route.snapshot.paramMap.get('name')

  images = environment.localstatic
  favoriteColor = ''

  message: any;
  subscription: Subscription;

  constructor(private _questionnaire: QuestionnaireService,
    private route: ActivatedRoute,
  ) { }


  ngOnInit(): void {
   
  }

  ngOnChanges(changes: SimpleChanges): void {

  }


  ngOnDestroy() {
  }


}
